import { useEffect, useState } from "react"

const usePWA = () => {
  const [showBanner, setShowBanner] = useState(false)

  useEffect(() => {
    const UA = navigator.userAgent
    const iOS = UA.match(/iPhone/)

    const standalone =
      window.matchMedia("(display-mode: standalone)").matches ||
      ("standalone" in navigator && navigator.standalone === true)

    const isPWA = !!(standalone || (iOS && !UA.match(/Safari/)))

    if (iOS && !isPWA) {
      const lastDismissed = localStorage.getItem("pwaBannerDismissed")
      const now = new Date().getTime()
      if (
        !lastDismissed ||
        now - parseInt(lastDismissed) > 24 * 60 * 60 * 1000
      ) {
        setShowBanner(true)
      }
    }
  }, [])

  const dismissBanner = () => {
    localStorage.setItem("pwaBannerDismissed", new Date().getTime().toString())
    setShowBanner(false)
  }

  return { showBanner, dismissBanner }
}

export default usePWA
